export default __webpack_public_path__ + "locales/lv/Settings.json?hash=aba25a45acffb12445831cda65158c94";